import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    removeAllFromVisibleTracks, pinnedTracksSelector,
    reportIDsSelector, setbottomView
} from '../../features/datacenter/historySlice';
import { getReportList } from '../../features/datacenter/reportSlice';
import { blue } from '@mui/material/colors';
import GetAppIcon from '@mui/icons-material/GetApp';
import { Paper, Typography, Grid, ButtonGroup, Button, Avatar } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTheme } from '@mui/material/styles';
import TrackSearchForm from './TrackSearchForm';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: useTheme().spacing(1),
        },
    },
    small: {
        width: useTheme().spacing(2),
        height: useTheme().spacing(2),
        color: '#fff',
        backgroundColor: blue[500],
    },
}));

const TrackViewTop = () => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const pinnedTracks = useSelector(pinnedTracksSelector);
    const reportIDs = useSelector(reportIDsSelector);
    const [searchModalOpen, setSearchModalOpen] = useState(false);

    const handleSearchModalOpen = () => {
        setSearchModalOpen(true);
    };
    const handleSearchModalClose = () => {
        setSearchModalOpen(false);
    }

    useEffect(() => {
        //console.log("Get track list");
        dispatch(getReportList());
    }, [dispatch]);

    return (
        <Paper>
            <div style={{
                marginLeft: '15px',
            }}>
                <Grid container spacing={1}>
                    <Grid item sm={12}>
                        <Typography variant="h6">
                            <b>Tracks</b>
                        </Typography>
                    </Grid>

                    <Grid item sm={12}>
                        <ButtonGroup color="primary" variant="outlined" size="small">

                            <Button
                                onClick={handleSearchModalOpen}
                                startIcon={<GetAppIcon color="primary" />}
                            >
                                Get Tracks
                            </Button>
                            <Button
                                onClick={() => dispatch(setbottomView('trackList'))}
                                endIcon={
                                    <Avatar className={classes.small}>
                                        <Typography variant="caption">
                                            {reportIDs.length}
                                        </Typography>
                                    </Avatar>
                                }
                            >
                                Saved Tracks
                            </Button>
                            {
                                pinnedTracks.length > 0 &&
                                <Button
                                    onClick={() => dispatch(removeAllFromVisibleTracks())}
                                >
                                    Unpin All
                                </Button>
                            }

                        </ButtonGroup>
                    </Grid>
                    <Grid item>
                        <div style={{ height: '10px' }}></div>
                    </Grid>
                </Grid>
            </div>
            <TrackSearchForm
                searchModalOpen={searchModalOpen}
                handleSearchModalClose={handleSearchModalClose}
            />
        </Paper>
    );
}

export default TrackViewTop;